<template>
    <div
        class="chat-wrapper"
        ref="chat-container"
        :style="`max-height: ${height}px`"
        v-chat-scroll="{ always: false, scrollonremoved: true, smoothonremoved: false }"
    >
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "ChatWrapper",
    props: {
        height: {
            type: Number,
            default: 350
        },
        loadedAll: {
            type: Boolean,
            required: true
        },
        scrollLength: {
            type: Number,
            default: 800
        }
    },
    /* mounted() {
        this.$refs["chat-container"].addEventListener("scroll", this.scroll);
    },
    beforeDestroy() {
        this.$refs["chat-container"].removeEventListener("scroll", this.scroll);
    },*/
    methods: {
        scroll() {
            if (this.$refs["chat-container"].scrollTop <= this.scrollLength) {
                if (!this.loadedAll) {
                    this.$emit("loadMore");
                }
            }
        }
    }
};
</script>

<style lang="scss">
.chat-wrapper {
    overflow-y: auto;
    @media (max-width: 768px) {
        min-height: calc(100vh - 400px);
        max-height: calc(100vh - 400px) !important;
    }
}
.chat__main-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 40px;
}
</style>
